import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentPt = () => {
    return (
        <HighlightedText
            text="VOCÊ GANHOU 400 GIROS GRÁTIS"
            highlights={[{ word: '400' }]}
            breakAfterWords={['GANHOU']}
            className={styles.text_content}
        />
    )
}
